import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, MapSeriesOption, number } from 'echarts';

import {
    DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
    EchartsMapChartProps,
    EchartsMapFormData,
    MapChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../types';
import {
    extractGroupbyLabel,
} from '../utils/series';
import { countyGeoJSON } from './countyMap';

export default function transformProps(
    chartProps: EchartsMapChartProps,
): Promise<MapChartTransformedProps> | MapChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    //   console.log(queriesData)
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      tooltipFormat,
      selectRegion,
      metrics,
    }: EchartsMapFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };
    
    const metricLabels: string[] = [];
    for (let i =0; i < metrics?.length; i+=1) {
        const metricLabel = getMetricLabel(metrics[i]);
        metricLabels.push(metricLabel)
    }
    // console.log(metricLabel)
    // console.log(metric)
    // console.log(metrics)
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel)
      : [groupby].map(getColumnLabel);

    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
    //   console.log(labelMap)
    const { setDataMask = () => {} } = hooks;

    let seriesMin = NaN;
    let seriesMax = NaN;
    const seriesData = data.map(datum => {
      const label = extractGroupbyLabel({
        datum,
        groupby: groupbyLabels,
        coltypeMapping: {},
      });
    //   console.log('ops',label)
      seriesMin = !Number.isNaN(seriesMin) ?
        Math.min(seriesMin, number.numericToNumber(datum[metricLabels[0]]))
        : number.numericToNumber(datum[metricLabels[0]]);
      seriesMax = !Number.isNaN(seriesMax) ?
        Math.max(seriesMax, number.numericToNumber(datum[metricLabels[0]]))
        : number.numericToNumber(datum[metricLabels[0]]);
      const values = [];
      for (let i =0; i < metricLabels?.length; i+=1) {
        values.push({value:datum[metricLabels[i]],label:metricLabels[i]})
    }
      return {
        name: label,
        value: values,
      };
    });

  const series: MapSeriesOption[] = [
    {
      name: metricLabels[0],
      type: 'map',
      map: selectRegion,
      roam: true,
      animation: true,
      emphasis: {
        label: {
          show: true
        }
      },
      seriesMin,
      seriesMax,
      // @ts-ignore
      data: seriesData
    },
  ];
//   console.log(tooltipFormat)
  const echartOptions: EChartsCoreOption = {
    tooltip: {
      trigger: 'item',
      formatter: tooltipFormat
    },
    visualMap: {
      left: 'right',
      min: Math.round(seriesMin * .8),
      max: Math.round(seriesMax * 1.2),
      inRange: {
        color: [...DEFAULT_CHART_FORM_DATA.colorRange]
      },
      text: ['High', 'Low'],
      calculable: true
    },
    series,
  };

  return {
    formData,
    width,
    height,
    echartOptions,
    setDataMask,
    labelMap,
    groupby,
    geoJSON: countyGeoJSON[formData.selectRegion]
  };
}
  